import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";

const AdditionalInfoDiscountEdit = ({
  additionalInfoDiscountEditModalVisible,
  setAdditionalInfoDiscountEditModalVisible,
  sendDataToAdditionalInfoDiscountEdit,
  storeId,
  discountAmountPreviousValue,
  enabledAmountRoundOff
}) => {

  const isRoundOffMode = enabledAmountRoundOff === 0;

  const inputRegex = isRoundOffMode
    ? /^\d*$/
    : new RegExp(`^\\d*\\.?\\d{0,${enabledAmountRoundOff}}$`);


  const [customDiscountValue, setCustomDiscountValue] = useState("");

  useEffect(() => {
    // Check if selectedPackageItemValue is available
    const roundOffValue = discountAmountPreviousValue?.amount?.toFixed(0);
    setCustomDiscountValue(roundOffValue?.toString());
  }, [discountAmountPreviousValue]);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [errorText, setErrorText] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [showUpdateButton, setShowUpdateButton] = useState(false);

  const handleDiscountAmountChange = (text) => {

    if (text === "") {
      setCustomDiscountValue("");

      setErrorText("Please Enter Receive Amount");
      return;
    }

    if (!isRoundOffMode && text === ".") {
      setCustomDiscountValue(".");
      return;
    }

    if (!inputRegex.test(text)) return;

    const numericValue = parseFloat(text);

    const finalValue = isRoundOffMode ? String(Math.round(numericValue)) : text;


    if (!text) {
      setCustomDiscountValue("");
      setErrorText("Total cannot be empty or zero");
      setIsSubmitButtonPressed(true);
    }
    // else if (parseInt(text) > parseInt(discountAmountPreviousValue?.amount)) {
    //   setErrorText(
    //     "Entered Value Can Not Be Greater Then " +
    //       discountAmountPreviousValue?.amount?.toFixed(0)
    //   );
    //   setCustomDiscountValue(text);
    //   setIsSubmitButtonPressed(true);
    // }
    else {
      setCustomDiscountValue(finalValue);
      setErrorText("");
      setIsSubmitButtonPressed(false);
    }
  };

  const handleConfirmation = () => {
    if (!errorText) {
      sendDataToAdditionalInfoDiscountEdit({
        success: true,
        customDiscountValue: {
          ...discountAmountPreviousValue,
          amount: Number(Number(customDiscountValue)?.toFixed(enabledAmountRoundOff)),
        },
      });
      setAdditionalInfoDiscountEditModalVisible(false);
    }
    setShowUpdateButton(true);
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    sendDataToAdditionalInfoDiscountEdit({
      success: true,
      customDiscountValue: {
        ...discountAmountPreviousValue,
        amount: Number(Number(discountAmountPreviousValue?.amount)?.toFixed(enabledAmountRoundOff)),
      },
    });
    setAdditionalInfoDiscountEditModalVisible(
      !additionalInfoDiscountEditModalVisible
    );
    setErrorText("");
    setShowUpdateButton(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={additionalInfoDiscountEditModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!additionalInfoDiscountEditModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div>
              <div
                className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
                style={{
                  backgroundImage:
                    "radial-gradient(circle at left top, #2B70D7, #1752AA)",
                }}
              >
                <div></div>

                <p className=" text-4xl text-primary-50 font-semibold">
                  Discount Amount
                </p>
                <Button
                  label="x"
                  onClick={(e) => hide(e)}
                  text
                  className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
                ></Button>
              </div>
              <div className="mt-4 mb-1 mx-4">
                <div>
                  <div className="flex justify-content-between align-items-center">
                    <div>
                      <p className=" text-xl font-semibold">Discount Amount</p>
                    </div>

                    <div>
                      <InputText
                        placeholder="Amount"
                        value={customDiscountValue}
                        maxLength={50}
                        onChange={(e) =>
                          handleDiscountAmountChange(e.target.value)
                        }
                        keyFilter={isRoundOffMode ? "int" : /[\d.]/}
                        className=" bg-white-alpha-20 border-round-lg px-3 text-md "
                      ></InputText>
                    </div>
                  </div>
                </div>
              </div>

              {errorText && (
                <div
                  style={{
                    marginTop: 2,
                    marginBottom: 10,
                    alignSelf: "center",
                  }}
                >
                  <p>{errorText}</p>
                </div>
              )}
            </div>
            {!showUpdateButton && (
              <div>
                <div
                  style={{
                    marginTop: 2,
                    marginBottom: 10,
                    alignSelf: "center",
                  }}
                >
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: 18,
                      fontWeight: "700",
                      color: "red",
                    }}
                  >
                    Please Confirm Do You Want Edit
                  </p>
                </div>
              </div>
            )}

            <Button
              disabled={isSubmitButtonPressed}
              onClick={handleConfirmation}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                Update
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default AdditionalInfoDiscountEdit;
